import { format, parseISO, type Locale } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { enUS } from 'date-fns/locale/en-US';

const locales: Record<string, Locale> = {
  'pt-BR': ptBR,
  'en-US': enUS
};

const capitalizePortugueseDate = (dateString: string): string => {
  const words = dateString.split(' ');
  return words.map((word, index) => {
    if (word.length === 0) return word;
    if (index > 0 && word.toLowerCase() === 'de') return 'de';
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};

export const formatDate = (date: string | Date, formatStr: string, language: string = 'pt-BR'): string => {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  const formattedDate = format(dateObj, formatStr, { locale: locales[language] || ptBR });

  if (language === 'pt-BR') {
    return capitalizePortugueseDate(formattedDate);
  }

  return formattedDate;
};

export const formatCurrency = (amount: number): string => {
  return '\u00a3' + amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export const formatNumber = (num: number, language: string = 'pt-BR'): string => {
  if (language === 'pt-BR') {
    return num.toLocaleString('pt-BR');
  }
  return num.toLocaleString('en-US');
};
